import { Icon } from './chunk-VH4ICUUK.js';
import { tv } from './chunk-7NOFBOMW.js';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

var buttonStyles = tv({
  base: [
    "[&>svg] inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-lg text-sm font-medium transition-colors [&>svg]:h-4 [&>svg]:w-4",
    "focus-visible:ring-ring focus:ring-offset-2 focus-visible:outline-none focus-visible:ring-2"
  ],
  variants: {
    variant: {
      primary: "bg-primary text-primary-foreground hover:bg-primary-hover active:bg-primary-active",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary-hover active:bg-secondary-active",
      destructive: "bg-destructive text-destructive-foreground hover:bg-destructive-hover active:bg-destructive-active",
      outline: "border-input bg-background hover:bg-accent border",
      ghost: "hover:bg-accent hover:text-foreground active:bg-accent-hover",
      link: "text-primary hover:underline hover:underline-offset-4",
      success: "bg-success text-success-foreground hover:bg-success-hover active:bg-success-active",
      warning: "bg-warning text-warning-foreground hover:bg-warning-hover active:bg-warning-active"
    },
    size: {
      default: "h-10 px-4",
      sm: "h-9 px-3",
      lg: "h-11 px-8",
      icon: "p-3"
    },
    disabled: {
      true: "pointer-events-none opacity-50"
    },
    loading: {
      true: "pointer-events-none opacity-50"
    }
  },
  compoundVariants: [
    {
      variant: "link",
      className: "p-0 m-0 h-auto"
    }
  ],
  defaultVariants: {
    color: "primary",
    size: "default"
  }
});
var Button = forwardRef(
  ({
    className,
    variant = "primary",
    size = "default",
    asChild = false,
    disabled = false,
    loading = false,
    children,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    function renderComponent() {
      if (size === "icon") {
        return /* @__PURE__ */ jsx(Fragment, { children: loading ? /* @__PURE__ */ jsx(Icon, { name: "loader-circle", className: "animate-spin" }) : children });
      }
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        loading && /* @__PURE__ */ jsx(Icon, { name: "loader-circle", className: "animate-spin" }),
        children
      ] });
    }
    return /* @__PURE__ */ jsx(
      Comp,
      {
        role: "button",
        className: buttonStyles({ variant, size, disabled, loading, className }),
        ref,
        disabled: disabled || loading,
        "area-disabled": disabled || loading,
        ...props,
        children: renderComponent()
      }
    );
  }
);
Button.displayName = "Button";

export { Button, buttonStyles };
//# sourceMappingURL=chunk-FGS3ZZHC.js.map
//# sourceMappingURL=chunk-FGS3ZZHC.js.map